export default function PageHeader({ overline, title, subtitle, action }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 md:gap-6 border-b border-white/10 pb-6" data-testid="page-header">
      <div>
        <div className="overline mb-2">{overline}</div>
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight leading-tight">{title}</h1>
        {subtitle && <p className="text-neutral-400 mt-2 text-sm md:text-base">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0 flex flex-wrap gap-2">{action}</div>}
    </div>
  );
}
